module.exports = __webpack_public_path__ + "img/placeholder.4bb1b94c.jpg";